import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";

interface AddUserGroupMemberParams {
  groupId: string;
  userId: string;
}

export function useAddUserGroupMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ groupId, userId }: AddUserGroupMemberParams) =>
      api.addUserGroupMember(groupId, { user_id: userId }),
    onSuccess: (_data, { groupId }) => {
      queryClient.invalidateQueries({
        queryKey: ["user-groups", groupId, "members"],
      });
    },
  });
}
